export const ProductsEnum = {
    1: {
        name: 'Cuentas de Ahorro',
        apiName: 'CuentaDeAhorros',
    },
    2: {
        name: 'Launcher',
        apiName: 'Launcher'
    },
    3: {
        name: 'Tarjeta de credito',
        apiName: 'TarjetaDeCredito'
    },
    4: {
        name: 'Cuentas de Ahorro',
        apiName: 'CuentaDeAhorros',
    },
    5: {
        name: 'Vivienda',
        apiName: 'Vivienda'
    },
    6: {
        name: 'Banca Virtual',
        apiName: 'BancaVirtual'
    },
    7: {
        name: 'Libranzas',
        apiName: 'Libranzas'
    },
    8: {
        name: 'Libranzas',
        apiName: 'Libranzas'
    },
    9: {
        name: 'Banca movil',
        apiName: 'BancaMovil'
    },
    10: {
        name: 'Credito de consumo',
        apiName: 'LibreDestino'
    },
    11: {
        name: 'Cuenta de ahorros posventa',
        apiName: 'CuentaDeAhorros',
        appConfig: 'posventa'
    },
    12: {
        name: 'Mantiz',
        apiName: 'Mantiz'
    },
    13: {
        name: 'Crediservice',
        apiName: 'Crediservice'
    },
    14: {
        name: 'TC - Compra de Cartera',
        apiName: 'TarjetaDeCredito'
    },
    15: {
        name: 'Microcredito',
        apiName: 'Microfinanzas'
    },
    16: {
        name: 'Seguros',
        apiName: 'Seguros'
    },
    17: {
        name: 'CDT',
        apiName: 'CDT'
    },
    18: {
        name: 'Tarjeta de credito digital',
        apiName: 'TarjetaDeCredito'
    },
    19: {
        name: 'FiduBogota',
        apiName: 'FiduBogota'
    },
    20: {
        name: 'Cuenta de ahorros digital',
        apiName: 'CuentaDeAhorros'
    },
    21: {
        name: 'Pymes',
        apiName: 'Pymes'
    },
    22: {
        name: 'Vehiculos',
        apiName: 'Vehiculos'
    },
    23: {
        name: 'Microcredito rotativo',
        apiName: 'MicrocreditoRotativo'
    },
    24: {
        name: 'Adquirencia',
        apiName: 'Adquirencia'
    },
    25: {
        name: 'PQRS',
        apiName: 'PQRS'
    },
    26: {
        name: 'reservado carpeta digital zamudio',
        apiName: 'RESERVADO'
    },
    27: {
        name: 'Buy Now, pay later',
        apiName: 'BNPL'
    },
    28: {
        name: 'Tarjeta de credito digital oficina',
        apiName: 'TarjetaDeCredito'
    },
    29: {
        name: 'Secure data',
        apiName: 'SecureData'
    },
    30: {
        name: 'Seguro Digital',
        apiName: 'SeguroDigital'
    },
    31: {
        name: 'Autogestion Cobranzas',
        apiName: 'AutogestionCobranzas'
    },
    32: {
        name: 'Credito de consumo sarlaft',
        apiName: 'LibreDestino'
    },
    33: {
        name: 'E mas E',
        apiName: 'EmasE'
    },
    34: {
        name: 'Dato Seguro',
        apiName: 'DatoSeguro'
    },
    35: {
        name: 'Autenticador Empresas',
        apiName: 'AutenticadorEmpresas'
    },
    36: {
        name: 'Cuenta Corriente',
        apiName: 'CuentaDeAhorros'
    },
    40: {
        name: 'Vehiculos Tablet',
        apiName: 'Vehiculos'
    },
    42: {
        name: 'Crediconvenio',
        apiName: 'LibreDestino'
    },
    43: {
        name: 'FiduBogota',
        apiName: 'FiduBogota'
    },
    47: {
        name: 'Compra de cartera',
        apiName: 'TarjetaDeCredito'
    }
};



// WEBPACK FOOTER //
// ./src/app/enums/products-enum.ts